import { GridColDef } from "@mui/x-data-grid-pro";

export const GenerateGrupoAcessoColumns = (): GridColDef[] => {
    return [
        {
            field: "grupo",
            filterable: false,
            headerName: "Grupo",
            minWidth: 150,
            width: 300,
            sortable: false,
            renderCell: ({ value }) => {
                return (<div className="w-full h-full flex items-center">{value}</div>);
            }
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Descrição",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: ({ value }) => {
                return (<div className="w-full h-full flex items-center">{value}</div>);
            }
        },
    ];
}